<template>
  <div style="padding: 10px">
    <sc-btn text="打开全部" :handler="() => $refs.tree.setOpenedAll(true)" />
    <sc-btn text="关闭全部" :handler="() => $refs.tree.setOpenedAll(false)" />
    <sc-btn
      text="打开所在"
      :handler="() => $refs.tree.openNode($refs.tree.getSelectedNode().id)"
    />
    <sc-tree ref="tree" v-slot="{ node, children }">
      <sc-drag format="node" :data="node.id" :img="{ el: dragImg[node.id] }">
        <sc-tree-node :node="node" :menus="getMenus(node)">
          <div style="position: relative; height: 100%">
            <sc-drop
              accept="node"
              @drop="onDrag($event, node, 'before')"
              v-slot="{ hover, dragging }"
            >
              <div
                style="
                  position: absolute;
                  height: 50%;
                  width: 100%;
                  z-index: 10;
                "
                :style="{ borderTop: hover ? '1px solid red' : '' }"
                v-show="dragging"
              ></div>
            </sc-drop>
            <sc-drop
              accept="node"
              @drop="onDrag($event, node, 'inside')"
              v-slot="{ hover, dragging }"
            >
              <span
                class="title"
                :class="{ hover, dragging }"
                :ref="(el) => (dragImg[node.id] = el)"
              >
                {{ node.id }} {{ node.data.title }}
                <span @click="add(node)">添加</span>
              </span>
            </sc-drop>
          </div>
        </sc-tree-node>
      </sc-drag>
      <tran-reduce :show="node.opened">
        <div class="children">
          <template v-for="(child, index) in children" :key="index">
            <component :is="child" />
          </template>
        </div>
      </tran-reduce>
    </sc-tree>
  </div>
</template>

<script lang="ts">
import {defineComponent, ref} from 'vue';
import ScTree from '@/components/common/tree/ScTree.vue';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import {DataNode} from '@/components/common/tree/TreeUtil';
import TranReduce from '@/components/common/transition/TranReduce.vue';
import ScTreeNode from '@/components/common/tree/ScTreeNode.vue';
import ScDrag from '@/components/common/drag/ScDrag';
import ScDrop from '@/components/common/drag/ScDrop';

export default defineComponent({
  name: 'Test',
  components: { ScDrop, ScDrag, ScTreeNode, TranReduce, ScBtn, ScTree },
  setup() {
    return {
      id: 1,
      tree: ref<InstanceType<typeof ScTree>>(),
      dragImg: ref([]),
    };
  },
  mounted() {
    if (this.tree) {
      this.tree.setData({ data: { title: 'bbbbbbbbb' }, id: '0' });
    }
  },
  methods: {
    add(node: DataNode<any>) {
      node.opened = true;
      node.addChild({
        data: { title: 'bbbbbbbbb' },
        id: (++this.id).toString(),
      });
    },
    getMenus(node: DataNode<any>) {
      return [{ title: '添加', handler: () => this.add(node) }];
    },
    onDrag(ev: any, target: DataNode<any>, pos: 'before' | 'after' | 'inside') {
      if (this.tree) {
        this.tree.moveNodeTo(ev.data, target.id, pos);
        if (pos === 'inside') {
          target.setOpen(true);
        } else if (target.parent) {
          target.parent.setOpen(true);
        }
      }
    },
  },
});
</script>
<style lang="scss" scoped>
.title {
  border: 1px solid transparent;
}

.title.hover {
  border: 1px solid #0078d4;
}

.gap {
  position: absolute;
  height: 15px;
  width: 100%;
  z-index: -1;

  .border {
    height: 1px;
  }

  &.hover .border {
    background-color: #0078d4;
  }
}
</style>
